<common-confirm></common-confirm>
<common-alert></common-alert>

<h1 class="container-heading">Stock list {{stockType}}</h1>
<mat-card>
    <mat-card-content>

        <common-table2 *ngIf="listTable" [settings]="listTable" (gotData)="updateTotals($event)"
                       (onSearchChange)="searchParams = $event" [scrollHeightValue]="300">

            <div row0>
                <mat-checkbox [formControl]="availableOnly"
                              *ngIf="stockType === 'detailed' || stockType === 'summarized'">
                    Show available only
                </mat-checkbox>
            </div>
            <div row1 class="flex row align-center">
                <common-form-select *ngIf="!subWarehouses && hubList && hubList.length"
                                    [options]="hubList"
                                    [multiple]="true"
                                    [selectAll]="true"
                                    [search]="true"
                                    [value]="hubSelect.value"
                                    (onClose)="hubSelect.setValue($event)"
                                    class="margin-right-10"
                                    style="width: 250px"
                                    label="Hubs"></common-form-select>

                <common-form-select *ngIf="subWarehouses && subWarehouses.length"
                                    [options]="subWarehouses"
                                    [multiple]="true"
                                    [selectAll]="true"
                                    [search]="true"
                                    class="margin-right-10"
                                    (onClose)="subWarehouseSelect.setValue($event)"
                                    label="Sub-warehouses"></common-form-select>

                <common-form-select *ngIf="partners && partners.length"
                                    [options]="partners"
                                    [multiple]="true"
                                    [selectAll]="true"
                                    (onClose)="partnerSelect.setValue($event)"
                                    label="Partners"></common-form-select>

                <common-form-select *ngIf="!subWarehouses"
                                    [options]="countriesOptions"
                                    [multiple]="false"
                                    [selectAll]="true"
                                    [search]="true"
                                    [image]="{path:'assets/images/flags',ext:'svg'}"
                                    (onClose)="countrySelect.setValue($event)"
                                    [value]="countrySelect.value"
                                    style="width: 250px"
                                    label="Country"></common-form-select>

                <ng-container *ngIf="canAddInventory">
                    <ng-container *ngIf="stockType!=='summarized'">
                        <a *userAllowed="'add_inventories'" mat-raised-button color="primary" (click)="addPart()">
                            Add New
                        </a>
                    </ng-container>
                    <a mat-raised-button color="accent" (click)="upload()" *ngIf="stockType === 'detailed'">
                        Upload CSV
                    </a>
                </ng-container>
            </div>
        </common-table2>
    </mat-card-content>
</mat-card>
